// 예약 도메인 공용 상수

export const PRODUCT_SECTION_TYPE = {
  OIL_SET: 'oil_set',
  OIL_MISSION: 'oil_mission',
  TIRE_ROTATION: 'tire_rotation',
  AIR_CONDITIONER: 'air_conditioner',
  ANTIFREEZER: 'antifreezer',
  CAR_WASH: 'car_wash',
  SAFE_INSPECT: 'safe_inspect',
  BRAKE_PAD: 'brake_pad',
  EXTERIOR_REPAIR: 'exterior_repair',
  OIL_BRAKE: 'oil_brake',
  CABIN_FILTER: 'cabin_filter',
  WIPER_BLADE: 'wiper_blade',
  BATTERY: 'battery',
  SPARK_PLUG: 'spark_plug',
  TIRE: 'tire',
} as const

export const EXTRA_INSPECTION_STATUS = {
  GOOD: 'Good',
  CAUTION: 'Caution',
  REPLACEMENT_REQUIRED: 'ReplacementRequired',
} as const

// 노출 영역 구분 ID ex) 마이클(28) / 토스(59) / 웹 예약(60)
export const EXPOSURE_AREA = {
  MYCLE: 28,
  TOS: 59,
  WEB_RESERVATION: 60,
} as const

export const COUPON_REGISTER = {
  // 성공 메시지
  SUCCESS: '쿠폰 등록이 완료됐어요.',

  // 현장 결제 성공 메시지
  ONSITE_SUCCESS: '쿠폰을 등록했어요.',

  // 입력하지 않은 경우 메시지
  EMPTY: '쿠폰 코드를 입력해주세요.',

  // 에러 메시지
  INVALID_CODE: '정확한 쿠폰 코드를 입력해주세요.',
} as const

export const RESERVATION_STATUS_VALUES = {
  PAYMENT_COMPLETED: 'PaymentCompleted',
  SERVICE_COMPLETED: 'ServiceCompleted',
  CANCELLED: 'Cancelled',
  CONFIRMED: 'Confirmed',
  HOLDING: 'Holding',
  DEFERRED: 'Deferred',
  BLOCKED: 'Blocked',
} as const

// 엔진오일 디폴트 서비스 시간
export const ENGINE_OIL_DEFAULT_SERVICE_TIME = 60

export const CREATE_RESERVATION_CHANNEL = {
  WEB: 'WEB' as const,
  ON_SITE: 'WEB_ONSITE' as const,
}

export const PAYMENT_VERIFICATION = {
  INVALID_CAR_NUMBER: '올바른 차량번호를 입력해주세요.',
  REQUIRED_CAR_NUMBER: '차량번호를 입력해주세요.',
  REQUIRED_BUYER_NAME: '예약자명을 입력해주세요.',
  REQUIRED_TELEPHONE: '연락처를 입력해주세요.',
  REQUIRED_TERMS_AGREEMENT: '유의사항 및 약관동의를 선택해주세요.',
} as const

export const TERMS_TYPE_VALUES = {
  PRIVACY_POLICY: '개인정보 제3자 제공 동의',
  PAYMENT_SERVICE_TERMS: '결제 서비스 이용약관',
  CANCELLATION_POLICY: '취소 수수료 규정 동의',
  NOTICE_ALL: '유의사항 전체보기',
} as const

export const TERMS_TYPES = {
  PRIVACY_POLICY: 'privacy_policy',
  PRIVACY_POLICY_DETAIL: 'privacy_policy_detail',
  PAYMENT_SERVICE_TERMS: 'payment_service_terms',
  CANCELLATION_POLICY: 'cancellation_policy',
  NOTICE_ALL: 'notice_all',
} as const

/**
 * 예약 플로우 유형 (URL 파라미터 `type` 값)
 * - boxTruck: 포터/봉고(탑차) 전용 예약. 인트로부터 관통되어 차종 제한·업체 검색 필터·쿠폰 분기에 사용
 * - hiplus: 하이플러스 제휴 예약. 일반 웹예약 플로우와 동일하고 쿠폰만 하이플러스 전용으로 분기
 * - hiplusNew: 하이플러스 제휴 예약 새 버전. hiplus와 동일하되 쿠폰만 다름
 * - towncar: 타운카 차주 제휴 예약. 일반 웹예약 플로우와 동일하고 쿠폰만 타운카 전용으로 분기
 * - orangecard: E1 오렌지카드 고객 제휴 예약. 일반 웹예약 플로우와 동일하고 쿠폰만 오렌지카드 전용으로 분기
 * - tmap: 티맵 운전자 제휴 예약. 일반 웹예약 플로우와 동일하고 쿠폰만 티맵 전용으로 분기
 */
export const RESERVATION_TYPE = {
  BOX_TRUCK: 'boxTruck',
  HIPLUS: 'hiplus',
  HIPLUS_NEW: 'hiplusNew',
  TOWNCAR: 'towncar',
  ORANGECARD: 'orangecard',
  TMAP: 'tmap',
} as const

export type TReservationType =
  (typeof RESERVATION_TYPE)[keyof typeof RESERVATION_TYPE]
